/* src/app/workshop-defects/pages/workshop-timeline/workshop-timeline.component.scss */
.timelineToolbarContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background: #0f172a;
  border-radius: 0.5rem;
  border-bottom: 3px solid #006498;
  margin-bottom: 1.5rem;
}
.timelineToolbarContainer .btn-secondary {
  background: #1e293b !important;
  border: 1px solid #1e293b !important;
  color: #f1f5f9 !important;
  box-shadow: none !important;
}
.timelineToolbarContainer .btn-secondary:hover,
.timelineToolbarContainer .btn-secondary:focus {
  background: #006498 !important;
  border-color: #006498 !important;
  color: #fff !important;
}
.toolbarGroup {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.dateSelectorContainer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.btn-nav {
  background: transparent;
  border: 0;
  box-shadow: none !important;
  color: #f1f5f9;
}
.btn-nav i {
  font-size: 1.3rem;
}
.btn-nav:hover i {
  color: #4db8f0;
}
.dateSelectorBox {
  min-width: 16rem;
  text-align: center;
  font-size: 1.05rem;
  font-weight: 700;
  color: #f1f5f9;
}
.colorCodeContainer {
  flex-wrap: wrap;
}
.colorCodeChip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.75rem;
  color: #cbd5e1;
  font-weight: 500;
}
.colorCodeSwatch {
  display: inline-block;
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
}
.timelineLayout {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}
.unassignedPanel {
  flex: 0 0 17rem;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 1rem;
}
.unassignedTitle {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
}
.unassignedHint {
  font-size: 0.75rem;
  color: #6c757d;
  margin-bottom: 0.75rem;
}
.defectSearchInput,
.defectSeveritySelect {
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
}
.unassignedCard {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  background: #f1f3f5;
  border: 1px solid #dee2e6;
  border-radius: 0.35rem;
  padding: 0.5rem 0.6rem;
  margin-bottom: 0.5rem;
  cursor: grab;
  font-size: 0.8rem;
}
.unassignedCard:hover {
  border-color: #f99420;
}
.signOffBtn {
  align-self: flex-start;
  background: transparent;
  border: 1px solid #3f8f5f;
  color: #3f8f5f;
  border-radius: 0.25rem;
  font-size: 0.7rem;
  padding: 0.15rem 0.5rem;
  cursor: pointer;
}
.signOffBtn:hover {
  background: #3f8f5f;
  color: #fff;
}
.lanesWrap {
  flex: 1 1 auto;
  overflow-x: auto;
}
.lanesRow {
  display: flex;
  gap: 0.75rem;
  min-width: max-content;
}
.fitterLane {
  flex: 0 0 14rem;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.fitterLaneHeader {
  background: #1e293b;
  color: #f1f5f9;
  font-weight: 600;
  font-size: 0.85rem;
  padding: 0.6rem 0.75rem;
  text-align: center;
}
.absentTag {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.65rem;
  font-weight: 700;
  color: #fca5a5;
  text-transform: uppercase;
}
.laneAbsentLane {
  opacity: 0.85;
}
.laneAbsentLane .fitterLaneHeader {
  background: #7f1d1d;
}
.fitterLaneBody {
  min-height: 12rem;
  padding: 0.6rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.fitterLaneBody.drop {
  background: rgba(249, 148, 32, 0.12);
  outline: 2px dashed #f99420;
}
.fitterLaneBody.laneAbsentBody {
  background:
    repeating-linear-gradient(
      45deg,
      #f8f9fa,
      #f8f9fa 10px,
      #f1f3f5 10px,
      #f1f3f5 20px);
}
.laneEmptyHint {
  color: #adb5bd;
  font-size: 0.75rem;
  text-align: center;
  margin-top: 1rem;
}
.defectCard {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  border-radius: 0.35rem;
  padding: 0.4rem 0.6rem;
  color: #fff;
  font-size: 0.78rem;
  cursor: grab;
}
.defectCard.status-open {
  background: #64748b;
}
.defectCard.status-assigned {
  background: #006498;
}
.defectCard.status-in_progress {
  background: #f99420;
}
.defectCard.status-complete {
  background: #3f8f5f;
}
.cardTop {
  display: flex;
  flex-direction: column;
}
.cardActions {
  display: flex;
  gap: 0.5rem;
  padding-top: 0.2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}
.cardActions a,
.cardActions button {
  background: transparent;
  border: 0;
  padding: 0;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.75rem;
  cursor: pointer;
}
.cardActions a:hover,
.cardActions button:hover {
  color: #fff;
}
.cardVehicle {
  font-weight: 700;
}
.cardStatus {
  opacity: 0.9;
}
.cardDesc {
  color: #495057;
  font-size: 0.72rem;
}
.panelBackdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.4);
  z-index: 1049;
}
.editPanel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 32rem;
  max-width: 100vw;
  background: #fff;
  box-shadow: -4px 0 16px rgba(0, 0, 0, 0.2);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  animation: panelIn 0.18s ease-out;
}
@keyframes panelIn {
  from {
    transform: translateX(1.5rem);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.editPanelHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e9ecef;
}
.editPanelHeader h3 {
  margin: 0;
  font-size: 1.1rem;
}
.panelCloseBtn {
  background: transparent;
  border: 0;
  font-size: 1.5rem;
  line-height: 1;
  color: #6c757d;
  cursor: pointer;
}
.panelCloseBtn:hover {
  color: #000;
}
.editPanelBody {
  padding: 1.25rem;
  overflow-y: auto;
  flex: 1 1 auto;
}
/*# sourceMappingURL=workshop-timeline.component.css.map */
